import { ROUTING_NUMBER_REGXP, ACCOUNT_NUMBER_REGXP } from '../../../constants/patterns';

export default function payoutCheckingPreSubmit(formData) {
  const errors = [];

  if (!ROUTING_NUMBER_REGXP.test(formData.routingNumber)) {
    errors.push({
      field: 'routingNumber',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_ACCOUNT_ROUTING_NUMBER',
      currentValue: formData.routingNumber,
    });
  }

  if (!ACCOUNT_NUMBER_REGXP.test(formData.accountNumber)) {
    errors.push({
      field: 'accountNumber',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_ACCOUNT_NUMBER',
      currentValue: formData.accountNumber,
    });
  }

  if (formData.firstName.length < 1) {
    errors.push({
      field: 'firstName',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_ACCOUNT_FIRSTNAME',
      currentValue: formData.firstName,
    });
  }

  if (formData.lastName.length < 1) {
    errors.push({
      field: 'lastName',
      // https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-error_codes
      errorKey: 'payment.errors.INVALID_ACCOUNT_LASTNAME',
      currentValue: formData.lastName,
    });
  }

  return errors;
}
